<template>
    <el-drawer
        size="520px"
        :title="editId ? '编辑假期' : '新增假期'"
        class="custom_attendance_holiday_drawer"
        :visible.sync="holidayTplDialogVisible"
        :close-on-press-escape="false"
        :wrapperClosable="false"
        :append-to-body="true"
        :before-close="handleDialogClose"
    >
        <div class="custom_holiday_drawer_wrap">
            <div class="drawer_form_content" v-loading="loading">
                <el-form
                    :model="holidayForm"
                    :rules="holidayFormRules"
                    label-position="top"
                    ref="holidayForm"
                    size="small"
                >
                    <div class="illustrateText" style="margin-top: 0" v-if="holidayForm.is_comp_leave == 1">
                        说明:该假期类型已关联加班规则，部门字段不支持修改
                    </div>
                    <el-form-item label="假期名称" prop="name">
                        <el-input
                            :disabled="holidayForm.is_comp_leave == 1 ? true : false"
                            maxlength="20"
                            placeholder="请输入"
                            v-model="holidayForm.name"
                        >
                        </el-input>
                        <!--            <el-select v-model="holidayForm.name" placeholder="请选择">-->
                        <!--                <el-option  v-for="item in holidayList"  :key="item.id" :label="item.name"  :value="item.id">-->
                        <!--                </el-option>-->
                        <!--            </el-select>-->
                    </el-form-item>
                    <el-form-item label="假期描述" prop="holiday_type_desc">
                        <el-input
                            :rows="4"
                            maxlength="200"
                            placeholder="请输入"
                            type="textarea"
                            v-model="holidayForm.holiday_type_desc"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item
                        label="适用人员范围"
                        prop="json_rule.is_use_user_all"
                        style="margin-bottom: 8px !important"
                    >
                        <el-radio-group
                            :disabled="holidayForm.is_comp_leave == 1 ? true : false"
                            v-model="holidayForm.json_rule.is_use_user_all"
                        >
                            <el-radio :label="1">全部</el-radio>
                            <el-radio :label="0">自定义</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="json_rule.is_use_user_all" v-if="holidayForm.json_rule.is_use_user_all == 0">
                        <div class="customBox">
                            <ul class="customBoxForm">
                                <li>
                                    <p>部门包含</p>
                                    <el-select
                                        v-model="didTitle"
                                        multiple
                                        :popper-append-to-body="false"
                                        @remove-tag="handleRemoveDepTag"
                                        placeholder="请选择部门"
                                    >
                                        <el-option style="height: auto; padding: 0" value="didTitle">
                                            <el-tree
                                                :expand-on-click-node="false"
                                                ref="depTree"
                                                node-key="relate_id"
                                                :data="depOptions"
                                                size="mini"
                                                :props="{ children: 'children', label: 'relate_name', id: 'relate_id' }"
                                                show-checkbox
                                                check-on-click-node
                                                default-expand-all
                                                @check="handleCheckDepNode"
                                                check-strictly
                                            >
                                            </el-tree>
                                        </el-option>
                                    </el-select>
                                </li>
                                <li>
                                    <p>性别包含</p>
                                    <el-select v-model="holidayForm.json_rule.use_user.gender" placeholder="请选择">
                                        <el-option
                                            v-for="item in userGenderData"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>

                    <!-- <el-form-item label="带薪假" prop="have_salary">
                        <el-radio-group v-model="holidayForm.have_salary">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item> -->

                    <el-form-item label="最小请假单位" prop="time_unit">
                        <el-radio-group v-model="holidayForm.time_unit" :disabled="holidayForm.json_rule.is_continuous_holidays == 1">
                            <el-radio label="day">天</el-radio>
                            <el-radio label="ampm">半天</el-radio>
                            <el-radio label="hour">小时</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="计入请假的日期类型" prop="json_rule.record_date_type">
                        <template #label>
                            <el-tooltip
                                class="item"
                                width="423"
                                effect="dark"
                                content=""
                                placement="top-start"
                                popper-class="custom-time_type_tooltip"
                            >
                                <div slot="content">
                                    <p style="line-height: 22px; font-size: 14px">
                                        工作日：请假时段中内不包含员工的休息日，节假日，仅计算工作日请假天数<br />休息日、节假日：请假时段中包含员工的休息日、节假日，也会计入请假天数，适用于产假等需要计算自然日的假期
                                    </p>
                                </div>
                                <span
                                    >计入请假的日期类型
                                    <span class="cursor-wrap"><i class="iconfont icon-bangzhuzhongxin cursor"></i></span
                                ></span>
                            </el-tooltip>
                        </template>
                        <el-checkbox-group v-model="holidayForm.json_rule.record_date_type">
                            <el-checkbox label="work">工作日</el-checkbox>
                            <el-checkbox label="rest">休息日</el-checkbox>
                            <el-checkbox label="holiday">节假日</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="连续请假限制" prop="json_rule.is_continuous_holidays">
                        <el-radio-group
                            @change="consecutiveHolidaysChange"
                            v-model="holidayForm.json_rule.is_continuous_holidays"
                        >
                            <el-radio :label="0">不限制</el-radio>
                            <el-radio :label="1">限制</el-radio>
                        </el-radio-group>
                        <el-tooltip
                            class="item"
                            width="423"
                            effect="dark"
                            content=""
                            placement="top"
                            popper-class="custom-consecutive_holidays_tooltip"
                        >
                            <div slot="content">
                                <p style="line-height: 22px; font-size: 14px">
                                    限制后，为连续假期，适用于婚假、产假等，开始时间和结束时间为固定额度。<br />如：婚假为10天，选择开始时间为1号，结束时间自动带入10号，结束时间不可更改。
                                </p>
                            </div>
                            <span class="cursor-wrap"><i class="iconfont icon-bangzhuzhongxin cursor"></i></span>
                        </el-tooltip>
                        <div class="consecutive_holidays_txt" v-if="holidayForm.json_rule.is_continuous_holidays == 1">
                            <span>固定额度</span>
                            <el-input
                                size="small"
                                placeholder="请输入"
                                v-model="holidayForm.json_rule.continuous_holidays_day"
                            >
                            </el-input
                            >天
                        </div>
                    </el-form-item>

                    <el-form-item label="是否限额" prop="balance_rule" style="margin-bottom: 8px !important" v-if="holidayForm.json_rule.is_continuous_holidays != 1">
                        <el-radio-group
                            :disabled="holidayForm.is_comp_leave == 1 ? true : false"
                            v-model="holidayForm.balance_rule"
                        >
                            <el-radio :label="0">不限额</el-radio>
                            <el-radio :label="1">限额（前往员工假期余额进行编辑）</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item prop="balance_rule" v-if="holidayForm.balance_rule == 1">
                        <div class="customBox">
                            <div class="customTitle">发放规则</div>
                            <div class="customBoxForm">
                                <template v-if="holidayForm.is_comp_leave == 1">
                                    <el-form-item label="发放周期" prop="">
                                        <el-input disabled="true" placeholder="" value="按加班时长转入"> </el-input>
                                    </el-form-item>
                                </template>
                                <template v-else>
                                    <el-form-item label="发放周期" prop="check_limit_balance_true_rule.cycle">
                                        <el-select
                                            @change="cycleChange"
                                            placeholder="请选择"
                                            v-model="holidayForm.check_limit_balance_true_rule.cycle"
                                        >
                                            <el-option
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                v-for="item in cycleData"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="周期开始时间"
                                        prop="check_limit_balance_true_rule.cycle_start_time"
                                    >
                                        <el-select
                                            @change="cycleStartTimeChange"
                                            placeholder="请选择"
                                            v-model="holidayForm.check_limit_balance_true_rule.cycle_start_time"
                                        >
                                            <el-option
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                v-for="item in cycleTimeData"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        label="请选择日期"
                                        prop="check_limit_balance_true_rule.cycle_start_time_day"
                                        v-if="holidayForm.check_limit_balance_true_rule.cycle_start_time == 2"
                                    >
                                        <el-date-picker
                                            format="MM-dd"
                                            placeholder="选择日期"
                                            popper-class="validityClass"
                                            type="date"
                                            v-if="holidayForm.check_limit_balance_true_rule.cycle == 'Y'"
                                            v-model="holidayForm.check_limit_balance_true_rule.cycle_start_time_day"
                                            value-format="MM-dd"
                                        >
                                        </el-date-picker>
                                        <el-input-number
                                            :controls="false"
                                            :max="28"
                                            :min="1"
                                            placeholder="请输入"
                                            v-if="holidayForm.check_limit_balance_true_rule.cycle == 'M'"
                                            v-model="holidayForm.check_limit_balance_true_rule.cycle_start_time_day"
                                        >
                                        </el-input-number>
                                    </el-form-item>

                                    <el-form-item
                                        label="发放频率"
                                        prop="check_limit_balance_true_rule.distribution_frequency_select"
                                    >
                                        <el-select
                                            disabled
                                            placeholder="请选择"
                                            v-model="
                                                holidayForm.check_limit_balance_true_rule.distribution_frequency_select
                                            "
                                        >
                                            <el-option
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                                v-for="item in frequencyData"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                        prop="check_limit_balance_true_rule.airdrop_cycle_day"
                                        v-if="
                                            holidayForm.check_limit_balance_true_rule.distribution_frequency_select == 1
                                        "
                                    >
                                        <div class="airdrop_cycle_day">
                                            每个周期发放
                                            <el-input
                                                placeholder="请输入"
                                                v-model="holidayForm.check_limit_balance_true_rule.airdrop_cycle_day"
                                            >
                                            </el-input>
                                            天
                                        </div>
                                    </el-form-item>
                                </template>

                                <el-form-item
                                    label="有效期"
                                    prop="check_limit_balance_true_rule.validity_period"
                                    style="margin-bottom: 0 !important"
                                >
                                    <el-radio-group
                                        class="airdrop_cycle_day"
                                        v-model="holidayForm.check_limit_balance_true_rule.validity_period"
                                        @change="validityPeriodChange"
                                    >
                                        <el-radio label="1">永久有效</el-radio>
                                        <el-radio label="2"
                                            >发起日起
                                            <el-input placeholder="请输入" v-model="validity_period_select1">
                                            </el-input>
                                            天内有效</el-radio
                                        >
                                        <el-radio label="3"
                                            >每年指定日期
                                            <el-date-picker
                                                format="MM-dd"
                                                placeholder="月日"
                                                popper-class="validityClass"
                                                type="date"
                                                v-model="validity_period_select2"
                                                value-format="MM-dd"
                                            >
                                            </el-date-picker>
                                            失效</el-radio
                                        >
                                        <br />
                                        <el-radio label="4"
                                            >次年
                                            <el-date-picker
                                                format="MM-dd"
                                                placeholder="月日"
                                                popper-class="validityClass"
                                                type="date"
                                                v-model="validity_period_select3"
                                                value-format="MM-dd"
                                            >
                                            </el-date-picker>
                                            失效</el-radio
                                        >
                                    </el-radio-group>
                                </el-form-item>

                                <div class="illustrateText" v-if="holidayForm.is_comp_leave != 1">
                                    <p>
                                        说明：<br />按每年发放周期为1月1日发放，每年1月1日发放新的假期 /
                                        按每月发放周期为每月1日发放，每月1日发放新的假期
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-form-item> -->

                    <el-form-item label="请假证明（附件）" prop="json_rule.is_have_appendix">
                        <el-radio-group v-model="holidayForm.json_rule.is_have_appendix">
                            <el-radio :label="0">无需上传附件</el-radio>
                            <el-radio :label="1">需上传附件</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div class="custom_drawer_footer">
                <el-button size="small" @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
                <el-button size="small" type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled"
                    >保存</el-button
                >
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { GetDepartmentList, CreateHolidayRule, UpdateHolidayRule , GetHolidayRuleDetail} from "@/api";
export default {
    name: "AttendanceHolidayTpl",
    props: {
        holidayTplDialogVisible: {
            type: Boolean,
            default: false,
        },
        editId: "",
    },
    data() {
        return {
            loading: false,
            holidayForm: {
                name: "",
                // holiday_type_config_id: "", //假期id
                holiday_type_desc: "", //这里是假期描述
                json_rule: {
                    is_use_user_all: 1, //1全员 0规则 [use_user]为规则
                    use_user: {
                        gender: "0", //男/女
                        user_department_list: [], // 包含的部门id
                    },
                    record_date_type: ["work"], // 计入请假的日期类型
                    is_continuous_holidays: 0, //是否连续假期 1是 0不是
                    continuous_holidays_day: 0, // is_continuous_holidays=1后的连续假期时长 单位天
                    is_have_appendix: 0, //是否需要附件 1需要 0不需要
                },
                // have_salary: 1, //是否为带薪假 1带薪 0不带薪
                time_unit: "ampm", //最小请假单位 天day 半天ampm 小时hour
                have_statutory_holidays: 1, //是否包含法定节假日 1是 0不是
                balance_rule: 0, //是否检查限额 1限额 0不限额
                check_limit_balance_true_rule: {
                    cycle: "", //Y 年 M 月
                    cycle_start_time: "", //周期开始时间 1入职 2指定某一天
                    cycle_start_time_day: "", //指定某一天[cycle_start_time_day 2023-10-01]
                    distribution_frequency_select: "1", //1固定频率
                    airdrop_cycle_day: "", //发放天数
                    validity_period: "1", //1永久有效 2发放日起xx天有效 3每年指定日期xx月xx日失[10-01] 4次年xx月xx日失效,
                    validity_period_select: "", //validity_period[validity_period_select]为对应的值
                },
            },
            validity_period_select1: "",
            validity_period_select2: "",
            validity_period_select3: "",
            holidayFormRules: {
                // holiday_type_config_id: [{required: true, message: '请选择假期名称'}],
                name: [{ required: true, message: "请输入假期名称" }],
                "json_rule.is_use_user_all": [{ required: true, message: "请选择适用人员范围" }],
                have_salary: [{ required: true, message: "请选择是否为带薪假" }],
                time_unit: [{ required: true, message: "请选择最小请假单位" }],
                have_statutory_holidays: [{ required: true, message: "请选择是否包含法定节假日" }],
                "json_rule.is_continuous_holidays": [{ required: true, message: "请选择是否为连续假期" }],
                balance_rule: [{ required: true, message: "请选择是否限额" }],
                "json_rule.is_have_appendix": [{ required: true, message: "请选择是否需要附件" }],
                "check_limit_balance_true_rule.cycle": [{ required: true, message: "请选择发放周期" }],
                "check_limit_balance_true_rule.cycle_start_time": [{ required: true, message: "请选择周期开始时间" }],
                "check_limit_balance_true_rule.cycle_start_time_day": [
                    { required: true, message: "请选择指定某一天日期" },
                ],
                "check_limit_balance_true_rule.airdrop_cycle_day": [{ required: true, message: "请输入发放天数" }],
                "check_limit_balance_true_rule.validity_period": [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == "1") {
                                callback();
                            } else if (value == "2") {
                                if (!this.validity_period_select1) {
                                    callback(new Error("请输入发起日起多少天内有效"));
                                } else {
                                    callback();
                                }
                            } else if (value == "3") {
                                if (!this.validity_period_select2) {
                                    callback(new Error("请选择每年指定什么时候失效"));
                                } else {
                                    callback();
                                }
                            } else if (value == "4") {
                                if (!this.validity_period_select3) {
                                    callback(new Error("请选择次年什么时候失效"));
                                } else {
                                    callback();
                                }
                            } else {
                                callback(new Error("请选择有效期"));
                            }
                        },
                    },
                ],
            },
            userGenderData: [
                { value: "0", label: "全部" },
                { value: "1", label: "男" },
                { value: "2", label: "女" },
            ],
            cycleData: [
                { value: "Y", label: "年" },
                { value: "M", label: "月" },
            ],
            cycleTimeData: [
                { value: "1", label: "员工入职日期" },
                { value: "2", label: "指定日期" },
            ],
            frequencyData: [
                { value: "1", label: "固定额度" },
                { value: "2", label: "按照司龄" },
            ],
            didTitle: [],
            depOptions: [],
            btnDisabled: false,
        };
    },
    async mounted() {
        if(this.editId) {
            this.getDetails()
        } else {
            this.getDepartmentList();
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:holidayTplDialogVisible", false);
        },
        getDetails() {
            GetHolidayRuleDetail({id: this.editId}).then(res=> {
                if(res.code === 200) {
                    this.holidayForm = JSON.parse(JSON.stringify(res.data))
                    this.getDepartmentList()
                }
            })
        },
        // 发放周期
        cycleChange() {
            this.holidayForm.check_limit_balance_true_rule.cycle_start_time_day = "";
        },
        //点击选择部门事件
        handleCheckDepNode(data, { checkedKeys }) {
            this.holidayForm.json_rule.use_user.user_department_list = checkedKeys;
            let didData = this.$refs.depTree.getCheckedNodes();
            this.didTitle = didData.map((item) => {
                return item.relate_name;
            });
        },
        // 删除部门
        handleRemoveDepTag(title) {
            let checkedNodes = this.$refs.depTree.getCheckedNodes();
            checkedNodes.splice(
                checkedNodes.findIndex((node) => node.title === title),
                1
            );
            this.$nextTick(() => {
                this.$refs.depTree.setCheckedNodes(checkedNodes);
                this.holidayForm.json_rule.use_user.user_department_list = checkedNodes.map(item=> item.relate_id)
            });
        },
        // 获取部门
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.depOptions = res.data || [];
                    if(this.editId && this.$refs.depTree){
                            this.$refs.depTree.setCheckedKeys(this.holidayForm.json_rule.use_user.user_department_list, true)
                            this.$nextTick(()=>{
                                let didData = this.$refs.depTree.getCheckedNodes()
                                this.didTitle  = didData.map((item)=>{
                                    return item.relate_name
                                })
                            })
                        }
                }
            });
        },
        // 连续请假限制
        consecutiveHolidaysChange(val) {
            if (val == 1) {
                this.holidayForm.time_unit = "day"
                this.holidayForm.have_statutory_holidays = 1;
            }
        },
        // 选择周期开始时间
        cycleStartTimeChange(val) {
            if (val == 2) {
                this.holidayForm.check_limit_balance_true_rule.cycle_start_time_day = "";
            }
        },
        // 选择有效期
        validityPeriodChange(val) {
            if (val == 1) {
                this.validity_period_select1 = "";
                this.validity_period_select2 = "";
                this.validity_period_select3 = "";
            }
            if (val == 2) {
                this.validity_period_select2 = "";
                this.validity_period_select3 = "";
            }
            if (val == 3) {
                this.validity_period_select1 = "";
                this.validity_period_select3 = "";
            }
            if (val == 4) {
                this.validity_period_select1 = "";
                this.validity_period_select2 = "";
            }
        },
        // 获取假期类型
        getHolidayRule() {
            let data = { is_show: 1 }; //1 展示 不包含销假 不传为包含
            $.post(
                "/admin/attendance/get_holiday_config_list",
                data,
                (res) => {
                    if (res.status === 0) {
                        this.holidayList = res.data;
                        if (this.id) {
                            this.getDetails();
                        }
                    }
                },
                "json"
            );
        },
        handleDialogConfirm() {
            this.$refs.holidayForm.validate((valid) => {
                if (valid) {
                    this.btnDisabled = true;
                    let params = {
                        name: this.holidayForm.name,
                        holiday_type_desc: this.holidayForm.holiday_type_desc,
                        time_unit: this.holidayForm.time_unit,
                        balance_rule: this.holidayForm.balance_rule,
                        json_rule: this.holidayForm.json_rule
                    };
                    if (!this.editId) {
                        // 新增
                        CreateHolidayRule(params).then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.loading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.handleDialogClose();
                                        this.$emit("callbackSuccess");
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.loading = false;
                                // this.$message.error(res.message);
                            }
                        }).catch(()=> {
                            this.btnDisabled = false;
                            this.loading = false;
                        })
                    } else {
                        // 编辑
                        params.id = this.editId
                        UpdateHolidayRule(params).then(res=> {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.loading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.handleDialogClose();
                                        this.$emit("callbackSuccess");
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.loading = false;
                                // this.$message.error(res.message);
                            }
                        }).catch(()=> {
                            this.btnDisabled = false;
                            this.loading = false;
                        })
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss">
.custom_attendance_holiday_drawer {
    .el-drawer__header {
        padding: 16px 24px;
        margin-bottom: 0;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
    }
}
.custom_holiday_drawer_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .drawer_form_content {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        .el-form {
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
            .customBox {
                .customBoxForm {
                    background: rgba(247, 248, 250, 1);
                    padding: 8px;
                    box-sizing: border-box;
                    position: relative;
                    .el-select {
                        width: 100%;
                    }
                }
                ul {
                    li {
                        margin-bottom: 16px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        > p {
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            line-height: 22px;
                            margin-bottom: 4px;
                        }
                    }
                }
            }
            .airdrop_cycle_day {
                .el-input {
                    width: 100px;
                }

                .el-radio {
                    margin-bottom: 10px !important;
                }
            }
            .illustrateText {
                border-radius: 4px;
                background: rgba(237, 240, 244, 1);
                padding: 8px;
                color: rgba(102, 102, 102, 1);
                font-size: 12px;
                line-height: 18px;
                box-sizing: border-box;
                margin-top: 10px;
            }
            .validityClass .el-date-picker__header .el-date-picker__header-label:nth-of-type(1) {
                display: none;
            }
            .el-input-number--small {
                display: block;
                width: 100%;
            }
            .el-input--small .el-input__inner {
                text-align: left;
            }
            .cursor-wrap {
                display: inline-block;
                margin-left: 4px;
                width: 22px;
                height: 22px;
                border-radius: 4px;
                text-align: center;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
            }
            .consecutive_holidays_txt {
                display: inline-block;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                .el-input {
                    width: 60px;
                    margin: 0 4px;
                    .el-input__inner {
                        height: 24px;
                        line-height: 24px;
                        padding: 0 3px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .custom_drawer_footer {
        padding: 10px 24px;
        border-top: 1px solid rgba(232, 232, 232, 1);
        text-align: right;
    }
}
.custom-time_type_tooltip {
    width: 428px !important;
    max-width: 428px !important;
    .popper__arrow {
        left: 138px !important;
    }
}
.custom-time_type_tooltip[x-placement^=top-start]  .popper__arrow {
        left: 138px !important;
    }
.custom-consecutive_holidays_tooltip {
    width: 428px !important;
    max-width: 428px !important;
    margin-left: 100px !important;
    .popper__arrow {
        left: 156px !important;
    }
}
</style>
